import { useQuery } from '@tanstack/react-query';
import { API_QUERY_KEYS } from 'consts';
import { getDocumentsUserRoles } from '../requests';
import type { GetDocumentsUserRolesRequestType } from '../types';

export const useGetDocumentsUserRoles = (
  documentId?: GetDocumentsUserRolesRequestType['documentId'],
) =>
  useQuery({
    queryKey: [API_QUERY_KEYS.documentsUserRoles, { documentId }],
    queryFn: () => getDocumentsUserRoles({ documentId: documentId! }),
    enabled: !!documentId,
  });
